/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Locked_Tier_Lists_DescriptionInputs */



/**
* | output |
* | --- |
* | "Rank a set on a drag-and-drop board, then share it as a link or an image." |
*
* @param {Nav_Locked_Tier_Lists_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_locked_tier_lists_description = /** @type {((inputs?: Nav_Locked_Tier_Lists_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Locked_Tier_Lists_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sortiere ein Set per Drag-and-drop auf einem Board und teile es als Link oder Bild.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Classez un set sur un tableau en glisser-déposer, puis partagez-le en lien ou en image.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("在可拖放的面板上给一个系列排名，然后以链接或图片分享。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("在可拖放的版面上為一個套組排名，再以連結或圖片分享。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("드래그 앤 드롭 보드에서 세트 순위를 매기고 링크나 이미지로 공유하세요.")
	return /** @type {LocalizedString} */ ("Rank a set on a drag-and-drop board, then share it as a link or an image.")
});